module.exports = __webpack_public_path__ + "img/google-play.a77151d6.png";